import apiClient from './apiClient';

const oderItemService = {
    // 주문 상품 등록
    addOrderItem: (orderData) => apiClient.post('/admin/order.add', orderData),
    // 회원정보조회
    fetchUserInfo: (phone_no) => apiClient.get('/user/user.infoByPhone',{ params: { phone_no:phone_no }}), // Fetch all partner requests

    // 상품검색
    fetchItemsName: (itemName) =>
        apiClient.get('/item/item.name', {
            params: {
                item_name: itemName || undefined  // 빈 문자열일 경우 undefined로 변환
            }
        }),

    // 지난주소 불러오기
    fetchLastAddress: (userId) => apiClient.get('/order/shipping.lastAddressList2',{ params: { user_id:userId }}), // Fetch all partner requests

    // 우편번호
};

export default oderItemService;